angular.module('services.newman.RulesService', [
  'global'
])

/**
 * The RulesService service stores methods used to
 * handle data for rules
 *
 * @class RulesService
 * @constructor
 * @module services.newman.RulesService
 */
.factory('RulesService', [
  'ModelsService',
  'TemplatesService',
  function (ModelsService, TemplatesService) {
    'use strict';

    var service = {

      rules: [],

      /**
       * Returns rules.  If a ruleId is
       * provided will return a single case.  If no
       * ruleId is provided will return all rules.
       *
       * @param {string} [ruleId] - return only a specific case
       * @param {boolean} [format=false] - flag to format content
       * @return {Object|Array<Object>} All entries
       */
      get: function get(ruleId, format) {
        var ret;

        service.rules = ModelsService.read('rules');

        if (ruleId) {
          ret = _.cloneDeep(ModelsService.find('rules', 'id', ruleId));
        } else {
          ret = service.rules;
        }

        if (format) {
          ret = {
            label: ret.label,
            content: ret.content
          };
        }

        return ret;
      },

      /**
       * Returns resolved objects from a list of IDs
       *
       * @param {Array<string>} list - Array of rule IDs
       * @return {Array<Object>} Collection of rule objects
       */
      getFromList: function getFromList(list) {
        var rules = [];

        _.forEach(list, function (id) {
          var ruleId = id;
          if (_.isObject(ruleId)) {
            ruleId = ruleId.id;
          }
          rules.push(
            ModelsService.find('rules', 'id', ruleId)
          );
        });

        return rules;
      },

      /**
       * Creates a new rule by merging provided date with
       * template
       *
       * @param {Object} [data] - Rule data
       * @return {Promise<Object>} New rule
       */
      create: function create(data) {
        var rule = {
          label: 'rule-' + uuid.v1(),
          content: {
            stop: true,
            active: true,
            totalPoints: 0,
            decision: {
              multiple: false,
              scored: true,
              model: 'none',
              maxAttempts: 1,
              choices: [
                {
                  correct: true,
                  target: '_self',
                  id: 'string',
                  feedback: 'string',
                  points: 0
                }
              ]
            }
          }
        };
        var endpoint = ModelsService.find('endpoints', 'label', 'rules');

        if (data) {
          rule = data;
        }

        return ModelsService.create(endpoint, rule);
      },

      /**
       * Updates existing decision by merging provided date with
       * template
       *
       * @param {string} id - Rule identifier
       * @param {Object} data - Rule data
       * @return {Promise<Object>} Updated rule
       */
      update: function update(id, data) {
        var rule = {
          content: data
        };

        var endpoint = ModelsService.find('rules', 'id', id);

        return ModelsService.update(endpoint, rule);
      },

      /**
       * Finds a template based on the provided key.  The key
       * also maps the type of rule being created.  The provided
       * data is then merged with the template based on the
       * type of rule being created.
       *
       * @param {Object} data - Rule data
       * @param {string} key - Key to find correct template
       * @return {Object} Merged data
       */
      mergeData: function mergeData(data, key) {
        var template;

        template = TemplatesService.getTemplate(key);

        template.rule.decision.correctFeedback = data.correctFeedback;
        template.rule.decision.incorrectFeedback = data.incorrectFeedback;

        template.rule.decision.correctTarget = data.correctTarget;
        template.rule.decision.incorrectTarget = data.incorrectTarget;

        template.rule.totalPoints = 0;

        if (key === 'state.learningOutcomes') {
          _.forEach(data.choices, function (choice, index) {
            template.rule.decision.choices[index] = template.rule.decision.choices[index] || {};
            template.rule.decision.choices[index].feedback = choice.feedback;
            template.rule.decision.choices[index].correct = true;
            template.rule.decision.choices[index].id = 'choice-' + uuid.v1();
            template.rule.decision.choices[index].points = choice.points;
            template.rule.decision.choices[index].target = choice.target;

            // add choice points to total points
            template.rule.totalPoints += choice.points;
          });
        } else if (
          key === 'state.choiceDecision'
          || key === 'state.contentView'
          || key === 'state.actionDecision'
          || key === 'state.knowledgeDecision'
        ) {
          template.rule.decision.scored = data.scored;
          template.rule.decision.multiple = data.multiple;
          template.rule.decision.maxAttempts = data.maxAttempts;
          template.rule.decision.model = data.model;
          _.forEach(data.choices, function (choice, index) {
            template.rule.decision.choices[index] = template.rule.decision.choices[index] || {};
            template.rule.decision.choices[index].feedback = choice.feedback;
            template.rule.decision.choices[index].incorrectFeedback = choice.incorrectFeedback;
            template.rule.decision.choices[index].correctFeedback = choice.correctFeedback;
            template.rule.decision.choices[index].correct = choice.correct;
            template.rule.decision.choices[index].id = 'choice-' + uuid.v1();
            template.rule.decision.choices[index].points = choice.points;
            template.rule.decision.choices[index].target = choice.target;

            // add choice points to total points
            if (choice.correct) {
              template.rule.totalPoints += choice.points;
            }
          });
        }

        return template;
      }

    };

    return service;
  }
]);
